import baseRequest  from '../baseRequest';
import AppConfig    from '../../app/config/AppConfig';

/* actions */
import * as Actions from '../../redux/actions';


class GetVehicleAdsPage extends baseRequest{

    constructor() {
        super();
        this.dispatch = null;
        this.response = null;
        this.name     = 'get Vehicle Ads Page';
        this.Config   = new AppConfig();
    }

    execute(dispatch) {
        this.dispatch = dispatch;
        this.call(this.Config.api.requests.getVehicleAdsPage);
    }

    //Parse successful response
    onSuccess() {
        this.updateState();
    }

    //Dispatch actions to update redux state
    updateState() {
        this.dispatch(Actions.setVehicleAdsPage(this.response.data));
    }
}


export default GetVehicleAdsPage;